import { render } from "./Allied.vue?vue&type=template&id=7669f1d8"
import script from "./Allied.vue?vue&type=script&lang=js"
export * from "./Allied.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__